



















































import mixins from 'vue-typed-mixins'

import Process from '@/components/workflow/Process.vue'
import Task from '@/components/workflow/Task'
import Measures from '@/survey/Measures.vue'
import Steps from '@/survey/elements/Steps.vue'
import AssessmentMixin from '../assessments/AssessmentMixin'
import { Process as ProcessType } from '@/store/workflow/types'

export default mixins(AssessmentMixin).extend({
  components: {
    Cdrisk10: require('@/survey/measures/cdrisk10/CD-Risk10.vue').default,
    CounselingQuestions: require('@/survey/measures/counselingQuestions/CounselingQuestions.vue')
      .default,
    Eurohis: require('@/survey/measures/eurohis/Eurohis.vue').default,
    Measures,
    Phq4: require('@/survey/measures/phq4/Phq4.vue').default,
    Sbqr: require('@/survey/measures/suicidal_ideation_and_behaviour/Suicidal_Ideation.vue')
      .default,
    Process,
    Steps,
    Task,
  },
  props: {
    timeOfMeasurement: {
      type: String,
      validator: (value: string) => ['postwl', 'post', 'fu1', 'fu2'].indexOf(value) > -1,
    },
    inProcess: {
      type: [String, Object],
    },
  },
})
